// extracted by mini-css-extract-plugin
export default {"container":"container--LZHjT","layout":"layout--rK3Pq","body":"body--cNfUi","stickyFooter":"stickyFooter--z6qK2"};